import { useContext } from 'react';

import { GaugeChartThresholdContext } from '../contexts/GaugeChartThresholdContext.js';

export const useGaugeChartThresholdContext = () =>
  useContext(GaugeChartThresholdContext);
